const userRoute = [
  {
    path: '/AccountSetup',
    name: 'AccountSetup',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/AccountSetup.vue'),
    meta: { title: '账户设置' }
  },
  {
    path: '/Balance',
    name: 'Balance',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/Balance.vue'),
    meta: { title: '余额' }
  },
  {
    path: '/AgentManagement',
    name: 'AgentManagement',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/AgentManagement.vue'),
    meta: { title: '代理商管理' }
  },
  {
    path: '/ChangePassword',
    name: 'ChangePassword',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/ChangePassword.vue'),
    meta: { title: '密码修改' }
  },
  {
    path: '/Order',
    name: 'Order',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/Order.vue'),
    meta: { title: '订单' }
  },
  // {
  //   path: '/PricesList',
  //   name: 'PricesList',
  //   component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/PricesList.vue'),
  //   meta: { title: '价格表' }
  // },
  // {
  //   path: '/RevisePrice',
  //   name: 'RevisePrice',
  //   component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/RevisePrice.vue'),
  //   meta: { title: '充值价格修改' }
  // },
  {
    path: '/QRcode',
    name: 'QRcode',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/QRcode.vue'),
    meta: { title: '二维码' }
  },
  {
    path: '/Grade',
    name: 'Grade',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/Grade.vue'),
    meta: { title: '等级表' }
  },
  {
    path: '/SwitchAccount',
    name: 'SwitchAccount',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/SwitchAccount.vue'),
    meta: { title: '切换账号' }
  },
  {
    path: '/firstLoginPage',
    name: 'firstLoginPage',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/firstLoginPage.vue'),
    meta: { title: '首次登录设置' }
  }
]

export default userRoute
